import { Injectable, inject } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { ApiService } from "../../../shared/src";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  oApiService = inject(ApiService);
  constructor(private routes: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    let oUserData = this.oApiService.getUserToken();
    if (oUserData != null) return true;
    this.routes.navigate(["/login"]);
    return false;
  }
}
